import { createContext } from 'react'

import { EducationHostedFormContextType } from './EducationHostedFormContext.types'

export const EducationHostedFormContext = createContext<EducationHostedFormContextType | undefined>(undefined)
